import React, { Suspense } from 'react';
import './Home.css';

import Button from '../../components/button/Button';
import { HomeScene } from '../../components/index';
import HomeLoader from '../../containers/home/HomeLoader';

const Home = () => {
    return (
        <Suspense fallback={<HomeLoader />}>
            <main className='Home'>
                <div className='Home__Container'>
                    {/* <div className="Home__Subtitle TextShadow">AUSTRALIAN WILDLIFE</div> */}
                    <div className='Home__Title '>VISOMEC</div>
                    <div className='Home__Subtitle TextShadow'>
                        CREATIVE DESIGNER & DEVELOPER
                    </div>
                    <div className='Home__Name'>MICHAEL ROBBA</div>

                    <div className='Home__ButtonContainer'>
                        <Button
                            link='/lightpollutionmap'
                            label='LIGHT POLLUTION MAP'
                        ></Button>
                    </div>
                </div>
                <div
                    className='Home__RenderContainer'
                    style={{ position: 'fixed', bottom: '0' }}
                >
                    <HomeScene></HomeScene>
                </div>
            </main>
        </Suspense>
    );
};

export default Home;
